{
	"title": "Erklärungen verwalten",
	"createDeclaration": "Erklärung erstellen"
}
